import { EmailAttachment } from './email-attachment.model';

export class MailDetail {

    // Properties
    toSelectedMailId = '';
    CCSelectedMailId = '';
    CCDisplayMailId = '';
    BCCSelectedMailId = '';
    BCCDisplayMailId = '';
    toMailId = '';
    CCMailId = '';
    BCCMailId = '';
    peopleIds = '';
    subject = '';
    message = '';
    attachments: EmailAttachment[] = [];
    personCodeMother: number;
    personCodeFather: number;

    // Constructor
    constructor() {
        for (let i = 0; i < 5; i++) {
            this.attachments.push(new EmailAttachment());
        }
    }
}